<section id="warranty" data-warranty-bridge class="warranty-bridge">
  <div class="warranty-bridge__halo warranty-bridge__halo--one" aria-hidden="true"></div>
  <div class="warranty-bridge__halo warranty-bridge__halo--two" aria-hidden="true"></div>

  <article class="warranty-panel">
    <header class="warranty-panel__header">
      <div>
        <p class="warranty-panel__badge">
          <mat-icon svgIcon="hero:verified_user"></mat-icon>
          {{ content.badge }}
        </p>
        <h2>{{ content.heading }}</h2>
      </div>
      <p>{{ content.introduction }}</p>
    </header>

    <div class="warranty-panel__modes">
      <section data-lookup-mode class="lookup-mode lookup-mode--warranty">
        <div class="lookup-mode__heading">
          <span><mat-icon svgIcon="hero:search"></mat-icon></span>
          <div>
            <h3>{{ content.warrantyPanelHeading }}</h3>
            <p>{{ content.warrantyPanelHelp }}</p>
          </div>
        </div>

        <div class="lookup-mode__fields">
          <label>
            <span>{{ content.serialLabel }} <small>{{ content.serialHint }}</small></span>
            <nz-input-group nzSize="large">
              <input
                nz-input
                type="text"
                placeholder="VD: VF-E200-882134"
                [ngModel]="serial"
                (ngModelChange)="serialChange.emit($event)"
              />
            </nz-input-group>
          </label>

          <label>
            <span>{{ content.phoneLabel }}</span>
            <nz-input-group nzSize="large">
              <input
                nz-input
                type="tel"
                placeholder="VD: 0901123456"
                [ngModel]="phone"
                (ngModelChange)="phoneChange.emit($event)"
              />
            </nz-input-group>
          </label>
        </div>

        <button data-action="lookup" nz-button nzType="primary" nzSize="large" (click)="lookup.emit()">
          <mat-icon svgIcon="hero:search"></mat-icon>
          {{ content.searchButtonLabel }}
        </button>
      </section>

      <section data-lookup-mode class="lookup-mode lookup-mode--product">
        <div class="lookup-mode__heading">
          <span><mat-icon svgIcon="hero:view_in_ar"></mat-icon></span>
          <div>
            <h3>{{ content.productPanelHeading }}</h3>
            <p>{{ content.productPanelHelp }}</p>
          </div>
        </div>

        <div class="lookup-mode__fields">
          <label>
            <span>{{ content.productTypeLabel }}</span>
            <nz-select
              nzSize="large"
              [ngModel]="lookupKind"
              (ngModelChange)="lookupKindChange.emit($event)"
              nzPlaceHolder="Chọn loại sản phẩm"
            >
              <nz-option nzValue="bike" nzLabel="Xe điện"></nz-option>
              <nz-option nzValue="machine" nzLabel="Máy nông nghiệp"></nz-option>
              <nz-option nzValue="appliance" nzLabel="Điện gia dụng"></nz-option>
            </nz-select>
          </label>

          <label>
            <span>{{ content.productCodeLabel }}</span>
            <nz-input-group nzSize="large">
              <input
                nz-input
                type="text"
                placeholder="Nhập mã hoặc ID sản phẩm"
                [ngModel]="lookupProductId"
                (ngModelChange)="lookupProductIdChange.emit($event)"
              />
            </nz-input-group>
          </label>
        </div>

        <div class="lookup-mode__actions">
          <button
            data-action="lookup-product"
            nz-button
            nzType="primary"
            nzSize="large"
            (click)="lookupProduct.emit()"
          >
            <mat-icon svgIcon="hero:open_in_new"></mat-icon>
            {{ content.productButtonLabel }}
          </button>
          <button
            data-action="browse-all"
            type="button"
            nz-button
            nzSize="large"
            (click)="browseAll.emit('all')"
          >
            <mat-icon svgIcon="hero:grid_view"></mat-icon>
            {{ content.catalogueButtonLabel }}
          </button>
        </div>
      </section>
    </div>

    <section
      *ngIf="submitted && result"
      class="warranty-result"
      [class.warranty-result--active]="result.status === 'active'"
      [class.warranty-result--expired]="result.status === 'expired'"
      [class.warranty-result--notfound]="result.status === 'notfound'"
      [attr.data-warranty-status]="result.status"
    >
      <div class="warranty-result__icon">
        <mat-icon
          [svgIcon]="result.status === 'active' ? 'hero:verified_user' : result.status === 'expired' ? 'hero:schedule' : 'hero:warning'"
        ></mat-icon>
      </div>
      <div class="warranty-result__copy">
        <strong>
          {{ result.status === 'active' ? 'Bảo hành còn hiệu lực' : result.status === 'expired' ? 'Bảo hành đã hết hạn' : 'Chưa tìm thấy thông tin' }}
        </strong>
        <p>{{ result.message }}</p>

        <dl *ngIf="result.record">
          <div><dt>Sản phẩm</dt><dd>{{ result.record.productName }}</dd></div>
          <div><dt>Serial</dt><dd>{{ result.record.serialNumber }}</dd></div>
          <div><dt>Hạn bảo hành</dt><dd>{{ result.record.warrantyEndDate | date: 'dd/MM/yyyy' }}</dd></div>
          <div><dt>Trung tâm hỗ trợ</dt><dd>{{ result.record.serviceCenter }} · {{ result.record.servicePhone }}</dd></div>
        </dl>
      </div>
      <button data-action="reset" type="button" nz-button (click)="reset.emit()">Tra cứu lại</button>
    </section>

    <footer class="warranty-panel__footer">
      <p>
        <mat-icon svgIcon="hero:lightbulb"></mat-icon>
        {{ content.tipLabel }}
        <code>VF-E200-882134</code>
        <code>0901123456</code>
      </p>
      <div>
        <button type="button" nz-button nzSize="small" (click)="browseAll.emit('bike')">
          <mat-icon svgIcon="hero:pedal_bike"></mat-icon>
          {{ content.browseBikesLabel }}
        </button>
        <button type="button" nz-button nzSize="small" (click)="browseAll.emit('machine')">
          <mat-icon svgIcon="hero:agriculture"></mat-icon>
          {{ content.browseMachinesLabel }}
        </button>
      </div>
    </footer>
  </article>
</section>
